var host = globalThis.OpenLeaf;
var ns = host && host.__runtime && host.__runtime["prosemirror-history"];
if (!ns) throw new Error("openleaf: prosemirror-history is not on the host runtime. Load openleaf.min.js before this bundle.");
module.exports = ns;
